import React, { Component } from 'react';
import {
  createStyles,
  Theme,
  WithStyles,
  Card,
  CardContent,
  withStyles,
  Typography,
  Grid,

} from '@material-ui/core';
import DashboardStatsContent from './DashboardStatsContent';
import DashboardStatsSyllabus from './DashboardStatsSyllabus';
import DashboardStatsUser from './DashboardStatsUser';
import { MyPATSelect } from '../../common';
import _ from 'lodash';


const styles = (theme: Theme) => createStyles({
  fontBold: {
    fontWeight: 800,
  },
  fontline: {
    display: 'inline',
  },
  bdShadow: {
    MozBoxShadow: '0px 0px 10px rgba(0, 0, 0, 0.168337)',
    WebkitBoxShadow: '0px 0px 10px rgba(0, 0, 0, 0.168337)',
  },
  mb1x: {
    marginBottom: theme.spacing.unit * 2,
  },
  cardShadow: {
    MozBoxShadow: '0px 0px 10px rgba(0, 0, 0, 0.168337)',
    WebkitBoxShadow: '0px 0px 10px rgba(0, 0, 0, 0.168337)',
  },
  cardContentRoot: {
    position: 'relative',
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    '& ul': {
      listStyle: 'none',
      display: 'flex',
      padding: 0,
      margin: 0,
    }
  },
  toggleDiv: {
    background: 'rgba(233, 239, 244, 0.48)',
    borderRadius: theme.shape.borderRadius,
  },
  toggle: {


    '& li': {
      ...theme.typography.body1,
      marginRight: theme.spacing.unit,
      borderRadius: theme.shape.borderRadius,

    },
    '& .active': {
      background: '#fff',
      paddingLeft: theme.spacing.unit,
      paddingRight: theme.spacing.unit,
    },
    '&:hover': {
      cursor: 'pointer',
    }
  },
  breadcrumb: {
    '& li': {
      ...theme.typography.body1,
      marginRight: theme.spacing.unit,
      borderRadius: theme.shape.borderRadius,

    },

  },

  dropdown: {
    float: "right",
    border: 'none',
    background: 'rgba(233, 239, 244, 0.48)',
    fontSize: 14,
    color: '#323C47',
    padding: theme.spacing.unit,
    borderRadius: theme.shape.borderRadius,
    height: 25,
  },
});

const noOfDays = [
  { key: 'Last 30 days', value: 30 },
  { key: "Last 60 days", value: 60 },
  { key: "Last 90 days", value: 90 },
  { key: "All", value: -1 }
];

interface DashboardStatsProps extends WithStyles<typeof styles> {

}

interface DashboardStatsState {
  active: string,
  formData: any,
}


class DashboardStats extends Component<DashboardStatsProps, DashboardStatsState>{
  constructor(props: DashboardStatsProps) {
    super(props);
    this.state = {
      active: 'content',
      formData: {
        noOfDays: 30,
      },
    }
    this.toggleComponent = this.toggleComponent.bind(this);
    this.handleChangeInNoOfDays = this.handleChangeInNoOfDays.bind(this);
  }

  handleChangeInNoOfDays(e: any) {
    let { formData } = this.state;
    let { name, value } = e.target;
    formData.noOfDays = value;
    this.setState({ formData });
  }

  toggleComponent(value: string) {
    let { formData } = this.state;
    switch (value) {
      case 'content':
        return <DashboardStatsContent
          noOfDays={formData.noOfDays}
        />

      case 'syllabus':
        return <DashboardStatsSyllabus />

      case 'user':
        return <DashboardStatsUser />

      default:
        return <DashboardStatsContent
          noOfDays={formData.noOfDays}
        />
    }

  }

  render() {
    const { classes } = this.props;
    const { formData } = this.state;
    return (

      <Card className={classes.cardShadow}>
        <CardContent className={classes.cardContentRoot}>
          <Grid container alignItems="center" spacing={16} className={classes.mb1x}>
            <Grid item xs>
              <Typography variant="h5" noWrap>
                My Library Overview
                </Typography>
            </Grid>
            <Grid item xs="auto" className={classes.toggleDiv}>
              <ul className={classes.toggle}>

                <li
                  className={this.state.active == 'content' ? 'active' : 'null'}
                  onClick={() => this.setState({ 'active': 'content' })}
                  id="content">
                  Content
                  </li>


                <li
                  className={this.state.active == 'syllabus' ? 'active' : 'null'}
                  onClick={() => this.setState({ 'active': 'syllabus' })} id="syllabus">
                  Syllabus

                  </li>


                <li
                  className={this.state.active == 'user' ? 'active' : 'null'} id="user"
                  onClick={() => this.setState({ 'active': 'user' })}>
                  User
                  </li>

              </ul>
            </Grid>
            <Grid item xs="auto">
              <MyPATSelect
                inputId="anything"
                name="anything"
                classes={{ input: classes.dropdown }}
              >
                {_.map(['All', 'Anythings'], (data, index) =>
                  <option key={`anything${index}`} value={data}>{data}</option>
                )}
              </MyPATSelect>
            </Grid>
            <Grid item xs="auto">
              <MyPATSelect
                inputId="noOfDays"
                name="noOfDays"
                classes={{ input: classes.dropdown }}
                value={formData.noOfDays}
                onChange={this.handleChangeInNoOfDays}
              >
                {_.map(noOfDays, (data, index) =>
                  <option key={`noOfDays${index}`} value={data.value}>{data.key}</option>
                )}
              </MyPATSelect>
            </Grid>
          </Grid>

          <Grid container className={classes.mb1x}>
            <ul className={classes.breadcrumb}>
              <li>All Contents</li>
            </ul>
          </Grid>

          {this.toggleComponent(this.state.active)}


        </CardContent>
      </Card>

    );

  }
};

// @ts-ignore
export default withStyles(styles)(DashboardStats);